/*
 HotelPolityka

 Tresc polityki prywatnosci webHotelBook
  
 historia: 
  PM 2021-11-27 - start
*/

import * as React from 'react';

import { Button, Theme, Typography, WithStyles, withStyles } from '@material-ui/core';

class HotelPolityka extends React.Component<WithStyles<typeof styles>> {

    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Typography variant='body2'>
                    W tej polityce prywatności wyjaśniono kwestie związane z przetwarzaniem danych osobowych podczas korzystania z Usług. Dane osobowe to wszelkie dane, które mogą być wykorzystane do identyfikacji Użytkownika. Ewentualne pytania na temat prywatności w vscHotelBook należy kierować na adres vsc.and.fcm@gmail.com.
                </Typography>
                <br />
                <Typography variant='body2'><b>Dane zbierane i przetwarzane przez aplikację</b></Typography>
                <Typography variant='body2'>
                    Do danych zbieranych przez aplikację zaliczamy podstawowe dane kontaktowe konieczne do korzystania z usługi takie jak: imię i nazwisko, adres e-mail oraz numer telefonu.
                </Typography>
                <Typography variant='body2'>
                    Ponadto zbieramy również dane z Twojego komputera, telefonu, tabletu lub innego urządzenia, z którego uzyskujesz dostęp do naszych usług. Obejmują one Twój adres IP, rodzaj przeglądarki internetowej, nazwę systemu operacyjnego czy ustawienia języka.
                </Typography>
                <br />
                <Typography variant='body2'><b>Dlaczego zbieramy i wykorzystujemy Twoje dane osobowe?</b></Typography>
                <Typography variant='body2'>Prosimy Cię o podanie danych w jednym celu – aby umożliwić skorzystanie z usług oferowanych przez aplikację.</Typography>
                <br />
                <Typography variant='body2'><b>Sposób i czas przechowywania danych</b></Typography>
                <Typography variant='body2'>Dane zbierane przez aplikacje przechowywane są na serwerze obsługującym aplikację i przechowywane są tak długo, jak to jest konieczne do skorzystania z usługi.</Typography>
                <br />
                <Typography variant='body2'><b>Udostępnianie danych firmom trzecim</b></Typography>
                <Typography variant='body2'>
                    Aplikacja nie zbiera żadnych danych osobowych ani innych danych użytkowników w celach marketingowych ani reklamowych. Dane klientów są przekazywane jedynie podmiotom, które wykonują daną usługę hotelową tj. hotelom będącym klientami VIRTUAL s.c. korzystającym ze strony vscHotelBook. Przekazane dane są przechowywane i przetwarzane zgodnie z politykami prywatności i regulaminem hotelu wykonującego wybraną usługę.
                </Typography>
                <br />
                <Typography variant='body2'><b>Wycofywanie danych i prośby o usunięcie</b></Typography>
                <Typography variant='body2'>
                    Użytkownikowi przysługuje prawo do sprostowania, usunięcia, ograniczenia przetwarzania, wniesienia sprzeciwu wobec przetwarzania oraz do przenoszenia danych osobowych oraz do informacji o fakcie zbierania i używania tych danych. Jeśli przetwarzanie odbywa się na podstawie zgody udzielonej przez Użytkownika, Użytkownik może w dowolnym momencie wycofać taką zgodę. Jeśli chcesz żeby Twoje dane nie były przetwarzane ani przechowywane przez administratora danych prosimy o kontakt w celu ich usunięcia z serwera i skrzynek mailowych za pośrednictwem korespondencji elektronicznej na adres: vsc.and.fcm@gmail.com.
                </Typography>
                <br />
                <Typography variant='body2'><b>Pliki cookie</b></Typography>
                <Typography variant='body2'>
                    {'Serwis vscHotelBook korzysta z plików cookie. Plik cookie mogą być wykorzystywane na różne sposoby, na przykład w celu zagwarantowania, że strona vscHotelBook działa poprawnie oraz na potrzeby analizy ruchu na stronie. Szczegóły dotyczące użycia plików cookie znajdziesz '}
                    <a href="https://vsc24.net/vscZasady/zasady/Cookies/Standard" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.button}`}
                        >
                            TUTAJ.
                        </Button>
                    </a>
                </Typography>
                <br />
                <Typography variant='body2'><b>Administrator danych</b></Typography>
                <Typography variant='body2'>Administratorem danych jest firma VIRTUAL s.c. z siedzibą w Rzeszowie o adresie 35-211 Rzeszów, A.Kamińskiego 8/4. W kwestiach związanych z polityką prywatności i przetwarzania danych osobowych przez aplikację mobilną prosimy o kontakt przy pomocy korespondencji elektronicznej na adres: vsc.and.fcm@gmail.com.</Typography>
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
    }
});

export default withStyles(styles)(HotelPolityka);
